import * as React from 'react'
import { useScreenWidth } from '../../theme/hooks/useScreenWidth'
import { TABLET } from '../../theme/breakpoints'
import { MobileHeader } from '../../molecules/MobileHeader/MobileHeader'
import { DesktopHeader } from '../../molecules/DesktopHeader/DesktopHeader'

export type Props = {
  className?: string
  isLoggedIn: boolean
  menuIsOpen: boolean
  userName: string
  accountUrl: string
  dashboardUrl: string
  onMenuToggle: (state?: boolean) => void
  onLogOut: () => void
  onLogIn: () => void
}

const PageHeader: React.FunctionComponent<Props> = ({
  isLoggedIn,
  userName,
  accountUrl,
  onLogOut,
  onLogIn,
  dashboardUrl,
  menuIsOpen,
  onMenuToggle,
  className,
}) => {
  const width = useScreenWidth()

  if (width < TABLET) {
    return (
      <MobileHeader
        className={className}
        menuIsOpen={menuIsOpen}
        toggleMenu={onMenuToggle}
        isLoggedIn={isLoggedIn}
        onLogIn={onLogIn}
        homeUrl={dashboardUrl}
        accountUrl={accountUrl}
      />
    )
  }

  return (
    <DesktopHeader
      className={className}
      isLoggedIn={isLoggedIn}
      onLogIn={onLogIn}
      accountUrl={accountUrl}
      onLogOut={onLogOut}
      userName={userName}
    />
  )
}

export default PageHeader
